import React from 'react';
import { motion } from 'framer-motion';
import AutoFitText from './AutoFitText';

const Footer = ({ userData }) => {
  return (
      <div className="bg-black">
        {/* Footer Content */}
        <footer className="relative pt-20">
        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Left Column - Personal Information */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                            <h3 className="text-white text-base font-semibold">Prabhakar Pandey</h3>
              </div>
              <div>
                <p className="text-[#999999] text-sm">Video Editor & Motion Graphics Designer</p>
                <p className="text-[#999999] text-sm">Crafting Clean, Modern Visual Stories For Brands.</p>
                <p className="text-[#999999] text-sm mt-3 font-medium">edit.prabhakar@gmail.com</p>
                <p className="text-[#999999] text-sm">Gurgaon | INDIA</p>
              </div>
            </div>
            
            {/* spacer to match layout */}
          </motion.div>


          {/* Right Column - Links */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
            className="space-y-6 lg:col-span-2 w-fit ml-auto"
          >
            <div className="grid grid-cols-2 gap-12">
              <div className="space-y-3">
                <a href="/" className="block text-[#999999] hover:text-white transition-colors duration-300 text-sm">Portfolio</a>
                <a href="/" className="block text-[#999999] hover:text-white transition-colors duration-300 text-sm">About</a>
                <a href="#contact" className="block text-[#999999] hover:text-white transition-colors duration-300 text-sm">Contact me</a>
              </div>
              <div className="space-y-3">
                <a href="https://instagram.com/__edit.pp" target="_blank" rel="noopener noreferrer" className="block text-[#999999] hover:text-white transition-colors duration-300">Instagram</a>
                <a href="https://in.linkedin.com/in/prabhakar-pandey-57482180" target="_blank" rel="noopener noreferrer" className="block text-[#999999] hover:text-white transition-colors duration-300">LinkedIn</a>
                <a href="https://youtu.be/NmS22FfrTHA" target="_blank" rel="noopener noreferrer" className="block text-[#999999] hover:text-white transition-colors duration-300">YouTube</a>
              </div>
            </div>
          </motion.div>
        </div>
        {/* Divider */}
        <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-12">
          <div className="border-t border-gray-800" />
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-6">
            <p className="text-gray-500 text-sm">© 2025 Prabhakar Pandey</p>
            {/* <p className="text-gray-500 text-sm">Template created by <span className="text-white">Sebadam</span></p> */}
            <p className="text-gray-500 text-sm"><span className="text-white"></span></p>
          </div>
        </div>
      </div>    
      </footer>

      {/* Large Prabhakar SMITH Background Text - After footer content */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        className="relative max-w-7xl mx-auto flex items-center justify-center px-4"
      >
        <AutoFitText className="w-full font-thin select-none bg-gradient-to-r from-[#383838] to-[#959595] bg-clip-text text-transparent text-center" min={24} max={220}>
          P.P WORKS
        </AutoFitText>
      </motion.div>
    </div>
  );
};

export default Footer;
